// src/modules/payments/hyrunReturn.ts

/**
 * La landing de Hyrun. Va fijo y no en una variable de entorno a propósito: si la variable faltara
 * en un build, el rebote se apagaría en silencio y la persona volvería a ver "No se encontró la
 * venta" sobre un cobro que sí entró. Un valor fijo falla, como mucho, en el despliegue.
 */
export const HYRUN_LANDING_URL = "https://hyrun.ticketin.ec/";

/**
 * Una inscripción de Hyrun que volvió de PayPhone a ESTA web.
 *
 * **Por qué llega acá una inscripción.** La cajita de PayPhone ignora el `responseUrl` que se le
 * pasa por constructor: el retorno lo decide la configuración de la tienda en el panel de PayPhone,
 * y la tienda (un solo `storeId`) es la misma para esta web y para las landings. Así que un pago
 * hecho en `hyrun.ticketin.ec` vuelve a `/payment/return`, donde no hay ninguna venta que buscar:
 * el 2026-10-15 eso dio "No se encontró la venta" (500) y luego 404 en `get_sale_by_id`, sobre un
 * cobro que SÍ se había realizado.
 *
 * Mientras PayPhone no registre el retorno de la landing —o no se abra una tienda aparte para
 * Hyrun—, esta web reconoce esas vueltas y las devuelve a donde pertenecen, antes de consultar
 * nada. Cuando PayPhone lo registre, esto se puede borrar entero.
 *
 * **Los dos formatos no se pisan.** La `orden` de una venta son los milisegundos de su creación
 * (`sale.setOrden(new Date().getTime() + "")` en `ApiWeb`): 13 dígitos. La de una inscripción es su
 * referencia pública —un UUID— con un sufijo en base 36 (`idDeTransaccionDeInscripcion`).
 */
const TX_INSCRIPCION =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}-[0-9a-z]+$/i;

export function esRetornoDeInscripcionHyrun(
  clientTransactionId: string | null | undefined,
): boolean {
  return typeof clientTransactionId === "string" && TX_INSCRIPCION.test(clientTransactionId);
}

/**
 * A dónde mandar la vuelta.
 *
 * Conserva TODOS los parámetros que puso PayPhone (`id`, `clientTransactionId`,
 * `transactionStatus`…) porque la landing los lee tal cual, y agrega el `pp_return=1` —o
 * `pp_cancel=1`— con el que entra a su propio camino de acreditación.
 */
export function urlDeRetornoHyrun(search: string, cancelado = false): string {
  const params = new URLSearchParams(search);
  params.delete("pp_return");
  params.delete("pp_cancel");
  params.set(cancelado ? "pp_cancel" : "pp_return", "1");
  return `${HYRUN_LANDING_URL}?${params.toString()}`;
}
